// Dove sta il login nel browser. "Resta collegato" acceso = localStorage (resta anche chiudendo il
// browser); spento = sessionStorage (si perde chiudendo la scheda). Si legge sempre da entrambi.
const CHIAVI = ['token', 'userType', 'userInfo'];

const archivio = () => (localStorage.getItem('token') ? localStorage : sessionStorage.getItem('token') ? sessionStorage : null);

const leggiToken = () => localStorage.getItem('token') || sessionStorage.getItem('token');

const leggiSessione = () => {
  const a = archivio();
  if (!a) return null;
  let userInfo = {};
  try { userInfo = JSON.parse(a.getItem('userInfo') || '{}'); } catch { userInfo = {}; }
  return { token: a.getItem('token'), userType: a.getItem('userType'), userInfo };
};

const cancellaSessione = () => {
  CHIAVI.forEach((k) => { localStorage.removeItem(k); sessionStorage.removeItem(k); });
};

const salvaSessione = ({ token, userType, userInfo }, restaCollegato = true) => {
  cancellaSessione();
  const a = restaCollegato ? localStorage : sessionStorage;
  a.setItem('token', token);
  a.setItem('userType', userType);
  a.setItem('userInfo', JSON.stringify(userInfo));
};

// Token nuovo (dopo il cambio password le altre sessioni non valgono più): nello stesso archivio di quello di prima
const sostituisciToken = (token) => {
  const a = archivio();
  if (a && token) a.setItem('token', token);
};

// Aggiorna i dati dell'utente nello stesso archivio in cui sta il token
const aggiornaInfoSessione = (userInfo) => {
  const a = archivio();
  if (a) a.setItem('userInfo', JSON.stringify(userInfo));
};

// Sessione scaduta o non più valida: si esce e il login lo dice ("La sessione è scaduta"), una volta sola
const SCADUTA = 'mk_sessione_scaduta';
const segnaSessioneScaduta = () => { try { sessionStorage.setItem(SCADUTA, '1'); } catch { /* archivio non disponibile */ } };
const sessioneEraScaduta = () => {
  try {
    const c = sessionStorage.getItem(SCADUTA) === '1';
    sessionStorage.removeItem(SCADUTA);
    return c;
  } catch { return false; }
};

export {
  leggiToken, leggiSessione, salvaSessione, cancellaSessione, aggiornaInfoSessione, segnaSessioneScaduta, sessioneEraScaduta, sostituisciToken,
};
